import React from "react";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";

const ObservationList = ({ items = [], onView }) => {
    const tHeads = [
        { title: "SN", width: "5%", className: "text-center" },
        { title: "Consent", width: "10%", className: "text-left" },
        { title: "Date Next Due", width: "20%", className: "text-left" },
        {
            title: "rationale",
            width: "20%",
            className: "text-left",
        },
        { title: "Date Created", width: "20%", className: "text-left" },

        {
            title: "Staff",
            width: "15%",
            className: "text-left",
        },
        {
            title: "Actions",
            width: "10%",
            className: "text-center",
        },
    ];

    if (items.length)
        return (
            <>
                <table className="table table-bordered">
                    <thead>
                        {tHeads.map((item) => (
                            <td style={{ width: item.width, backgroundColor: "aliceblue" }} className={item.className} key={item.title}>
                                {item.title}
                            </td>
                        ))}
                    </thead>
                    <tbody>
                        {items.map((item, idx) => (
                            <tr key={item.id}>
                                <td className="text-center">
                                    <strong>{idx + 1}</strong>
                                </td>
                                <td>{item.consent}</td>
                                <td>{cleanDate(item.nextDate)}</td>
                                <td className="text-left">{item.rationale}</td>
                                <td>{cleanDate(item.date)}</td>
                                <td className="text-left">
                                    <StaffProfileCard item={item.author} />
                                </td>

                                <td className="text-center">
                                    <button onClick={() => onView(item)} title="View" className="mdl-button mdl-button--icon mdl-button--colored btn-default">
                                        <i className="material-icons text-primary">arrow_right_alt</i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        );

    return (
        <>
            <div className="row fade-in">
                <div className="col-12 text-center mt-5 pt-5">
                    <i className="material-icons text-pink" style={{ fontSize: "4em" }}>
                        info
                    </i>
                    <br />
                    <span style={{ fontSize: "20px" }}>No Physical Health Observation has been recorded!</span>
                </div>
            </div>
        </>
    );
};

export default ObservationList;
